import {Enum} from 'enumify';

class HistogramTypeEnum extends Enum{}

     HistogramTypeEnum.initEnum({
         ColumnWithDrilldown: 'columnWithDrilldown'
        }
     );

export default HistogramTypeEnum;